import { render, staticRenderFns } from "./DashboardCenter.vue?vue&type=template&id=30ff65b9&lang=pug&"
import script from "./DashboardCenter.vue?vue&type=script&lang=js&"
export * from "./DashboardCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports